import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeftIcon, DownloadCloudIcon } from "lucide-react";
import { convertToIST } from "../utils/utils";
import CustomLoader from "./CustomLoader";
import NoDataComponent from "./NoDataComponent";
import { useQuery } from "react-query";
import { handleUsers } from "../axios";

const Users = () => {
  const { token } = useSelector((state) => state.auth);
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const columns = [
    {
      name: "S.No",
      selector: (_, index) => index + 1,
      sortable: true,
      width: "100px",
    },
    {
      name: "ID",
      selector: (row) => row.googleId,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Email",
      cell: (row) => (
        <div>
          <Link to={`/users-selected-websites/?email=${row.email}`}>
            <p className="hover:text-[#BC3810] cursor-pointer transition-all duration-300">
              {row.email}
            </p>
          </Link>
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "Mobile",
      selector: (row) => row.mobile,
      sortable: true,
    },
    {
      name: "Country",
      selector: (row) => row.country,
      sortable: true,
    },

    {
      name: "Created At",
      selector: (row) => convertToIST(row.createdAt),
      sortable: true,
    },
  ];

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  const { data: users, isLoading } = useQuery(["Users"], () =>
    handleUsers(config)
  );

  const customStyles = {
    headCells: {
      style: {
        borderRight: "1px solid #ddd",
        fontWeight: "bold",
        letterSpacing: "0em",
        alignItems: "center",
      },
    },
    cells: {
      style: {
        borderRight: "1px solid #ddd",
        alignItems: "center",
      },
    },
  };

  const filteredUsers = users?.data?.filter(
    (user) =>
      user?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user?.createdAt?.includes(searchTerm)
  );

  const handleDownload = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      "ID,Name,Email,Mobile,Country,CreatedAt \n" +
      filteredUsers
        .map((row) => {
          return `"${row.googleId}",${row.name},${row.email},${row.mobile},${
            row.country
          },"${convertToIST(row.createdAt)}"`;
        })
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "Users_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <p className="font-semibold antialiased tracking-normal text-[22px] w-full">
          Registered Users
        </p>
        <button
          onClick={() => navigate(-1)}
          className="bg-black text-white h-10 w-[130px] rounded-[8px] flex justify-center items-center gap-2 hover:ring-2 hover:ring-gray-300 transition-all duration-300"
        >
          <ArrowLeftIcon />
          <p>Back</p>
        </button>
      </div>

      <div className="my-4">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="outline-none ring-1 ring-gray-200 2xl:w-[300px] xl:w-[300px] lg:w-[300px] md:w-[300px] w-full h-10 rounded-[8px] indent-3 mt-2 focus:ring-2 focus:ring-indigo-300 transition-all duration-300"
          />
          <button
            onClick={handleDownload}
            className="bg-[#BC3810] text-white h-10 2xl:w-[230px] xl:w-[230px] lg:w-[230px] md:w-[230px] w-full rounded-[8px] flex justify-center items-center gap-2 hover:ring-2 hover:ring-[#f1a791] transition-all duration-300"
          >
            <DownloadCloudIcon />
            <p>Download Report </p>
          </button>
        </div>
      </div>
      <div className="border border-gray-200 mt-2">
        <DataTable
          columns={columns}
          data={filteredUsers}
          pagination
          paginationRowsPerPageOptions={[10, 50, 100, 500]}
          highlightOnHover
          progressPending={isLoading}
          progressComponent={<CustomLoader />}
          customStyles={customStyles}
          noDataComponent={<NoDataComponent />}
        />
      </div>
    </div>
  );
};

export default Users;
